import {defineMessages} from 'react-intl';
import {soundOn, soundOff} from '@sail/icons/react/Icon';
import {HeaderButton, Placement} from './HeaderButton';
import {useAnalytics} from '../../AnalyticsProvider';
import {useWidgetNotifications, useWidgetVisibility} from '../useWidget';

const messages = defineMessages({
  turnOn: {
    id: 'conversations_ui.widget.header.speakerButton.turnOn.label',
    description: 'Label used for the speaker button that turns sound on.',
    defaultMessage: 'Turn on',
  },
  turnOff: {
    id: 'conversations_ui.widget.header.speakerButton.turnOff.label',
    description: 'Label used for the spaeker button that turns sound off',
    defaultMessage: 'Turn off',
  },
});

type Props = {
  disabled?: boolean;
  tooltipEnabled?: boolean;
  color?: string;
  hoverColor?: string;
};

export function SpeakerButton({
  disabled = false,
  tooltipEnabled = true,
  color,
  hoverColor,
}: Props) {
  const analytics = useAnalytics();

  const {soundSetting, setSoundSetting} = useWidgetNotifications();
  const {visibility} = useWidgetVisibility();

  const toggleSoundSetting = () => {
    // If it's possible to call this helper, then the speaker button must be showing (i.e. soundSetting !== 'disabled')
    const resultingSoundSetting = soundSetting === 'on' ? 'off' : 'on';

    setSoundSetting(resultingSoundSetting);
    analytics.action('toggle_speaker_button_clicked', {
      resultingSoundSetting,
    });
  };

  if (soundSetting === 'disabled') {
    // don't show the speaker button if setting is disabled
    return null;
  }

  let label;
  let icon;
  let placement: Placement;

  if (soundSetting === 'off') {
    label = messages.turnOn;
    icon = soundOff;
  } else {
    label = messages.turnOff;
    icon = soundOn;
  }

  if (visibility === 'open') {
    placement = 'bottom left';
  } else {
    placement = 'left';
  }

  return (
    <HeaderButton
      testId="conversations-widget-header-speaker-button"
      key={icon.name}
      icon={icon}
      label={label}
      onPress={() => {
        toggleSoundSetting();
      }}
      tooltipPlacement={placement}
      disabled={disabled}
      color={color}
      hoverColor={hoverColor}
      tooltipEnabled={tooltipEnabled}
    />
  );
}
